module.exports = __webpack_public_path__ + "static/scen-3-c6b51b1285d8ae2edfe8c01adf69611f.svg";